const defaultTextEditorStyle = {
  PostButton: {
    backgroundColor: "#f9f9f9",
    padding: "4px",
    color: "#999",
    height: "37px",
    borderRadius: "0px",
    cursor: "default",
    zIndex: 2
  },
  toolbarWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: "3px"
  }
};

export default defaultTextEditorStyle;
